var audio_default = {
  "fontElementMap": "_1wqGi",
  "container": "zz4zN",
  "coverImageContainer": "orlZV",
  "customPlayer": "pnKcb",
  "slim": "Im-2T",
  "playPauseButton": "U1Mlw",
  "coverImage": "hSdxr",
  "trackDetailsContainer": "JXS0s",
  "controlsContainer": "mye-w",
  "controlsGroup": "p39ms",
  "sliderContainer": "v1tg2",
  "audioDuration": "PoUYt",
  "isLoading": "OBYDg",
  "audioDetails": "CjyEV",
  "authorName": "_2xrva",
  "title": "BpVv-",
  "dropdownMenuWrapper": "R9VQ4",
  "dropdownSelectedButton": "NxAU5",
  "dropdownContent": "kP7q5",
  "dropdownContentWithIcon": "SvXsR",
  "audioLoader": "Lop-R"
};
export {
  audio_default as default
};
//# sourceMappingURL=audio-scss.js.map
